import type { Column } from '@tanstack/react-table';
import { createContext, type ReactNode, useContext } from 'react';

export interface Option {
  id: string;
  displayName: string;
  count: number;
}

interface ExternalFilterOptions {
  options?: Record<string, Option[]>;
}

const ExternalFilterOptionsContext = createContext<ExternalFilterOptions>({});

export const ExternalFilterOptionsProvider = ({
  options,
  children,
}: {
  options?: Record<string, Option[]>;
  children: ReactNode;
}) => (
  <ExternalFilterOptionsContext.Provider value={{ options }}>
    {children}
  </ExternalFilterOptionsContext.Provider>
);

export const useExternalOptions = (
  column: Column<any, any> | undefined
): Option[] | undefined => {
  const { options } = useContext(ExternalFilterOptionsContext);
  return options && column?.id && options[column.id]
    ? options[column.id]
    : undefined;
};
